import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import {
  handleChange,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import { adicionarDias, hoje } from "../../../helpers/mesesHelper";
import PropTypes from "prop-types";

function ComprarCertificadoModal({ modalHook, valuesHook, compraCertificado }) {
  const { comprarCertificadoModal, setComprarCertificadoModal } = modalHook;
  const { values, setValues } = valuesHook;
  const minDate = hoje.toISOString().split("T")[0];
  const maxDate = adicionarDias(15);

  //Define o retorno da API nos valores dos campos
  React.useEffect(() => {
    const valorEcpf = values.ecpf * values.valor_ecpf;
    const valorEcnpj = values.ecnpj * values.valor_ecnpj;
    const valorTotal = valorEcpf + valorEcnpj;
    setValues((prevValues) => ({
      ...prevValues,
      valorEcpf,
      valorEcnpj,
      valor_total: valorTotal,
    }));
  }, [setValues, values]);

  return (
    <CommonModal
      title="Comprar certificados digitais"
      is_open_modal={comprarCertificadoModal}
      set_is_open_modal={setComprarCertificadoModal}
      size="md"
      buttons={
        <CommonButton
          key={`compra-certificado`}
          color="success"
          onClick={() => {
            compraCertificado();
          }}
        >
          Gerar cobrança
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInput
            label="Quantidade e-CNPJ"
            id="ecnpj"
            value={values.ecnpj}
            onChange={(e) => handleChangeNumeral(e, values, setValues, 0)}
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputValor
            label="Valor e-CNPJ"
            id="valor_ecnpj"
            value={values.valor_ecnpj}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_ecnpj",
                e.target.value,
                values,
                setValues
              );
            }}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInput
            label="Quantidade e-CPF"
            id="ecpf"
            value={values.ecpf}
            onChange={(e) => handleChangeNumeral(e, values, setValues, 0)}
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputValor
            label="Valor e-CPF"
            id="valor_ecpf"
            value={values.valor_ecpf}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_ecpf",
                e.target.value,
                values,
                setValues
              );
            }}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputValor
            label="Valor total"
            id="valor_total"
            value={values.valor_total}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_total",
                e.target.value,
                values,
                setValues
              );
            }}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputDate
            label="Vencimento"
            id="vencimento"
            value={values.vencimento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            min={minDate}
            max={maxDate}
          />
        </div>
      </div>
    </CommonModal>
  );
}

ComprarCertificadoModal.propTypes = {
  modalHook: PropTypes.shape({
    comprarCertificadoModal: PropTypes.bool.isRequired,
    setComprarCertificadoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  compraCertificado: PropTypes.func.isRequired,
};

export default ComprarCertificadoModal;
